import React from "react";

export function Separator({ className = "", ...props }) {
  return <div className={className} {...props} />;
}